import angular from 'angular';
import fp from 'micro-fp';

export default function filterOut() {
  return function link(input, out, matcher) {
    if (!out || !input) {
      return input;
    }

    if (angular.isString(matcher)) {
      const mapOut = fp.compose(fp.filter(fp.id), fp.map(fp.prop(matcher)));
      const or = fp.curry((f1, f2, arg) => f1(arg) || f2(arg));
      const doesNotInclude = fp.compose(fp.not, fp.includesIn(mapOut(out)), fp.prop(matcher));
      const filterFn = fp.filter(or(fp.not, doesNotInclude));
      return filterFn(input);
    }

    return fp.filter(fp.compose(fp.not, fp.includesIn(out)))(input);
  };
}
